import FilePreview from './FilePreview';
import PDFPreview from './PDFPreview';

export default FilePreview;
export {
  PDFPreview
}
